import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";

import { IOperationData, IListTextInputOperation, ISelectCardOption } from "../../../constants/types";
import Icon from "../../icon/Icon";

import './ListTextInputOperation.scss'
import { t } from "i18next";

interface Props extends WithTranslation {
    operation: IListTextInputOperation,
    data: IOperationData
};

class ListTextInputOperationMinimized extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    render() {
        const { t, operation, data } = this.props;
        const res = operation.options.flatMap(op => data?.value?.[op.key] ? { label: op.label, value: data?.value?.[op.key].value } : [])
        return res.map(r => <>
            <div className="render-select-card-operation" >
                <span style={{ fontWeight: '600' }}>
                    {t(r.label as unknown as TemplateStringsArray)}
                </span>
                {": "}{t(r.value as unknown as TemplateStringsArray)}
            </div>

        </>
        )
        return <></>
    }
};

export default withTranslation()(ListTextInputOperationMinimized);